import { DateFilterField } from '../../../components/tables/filterForms/DateFilterField';
import { FilterField } from '../../../components/tables/filterForms/FilterForm';
import { Filter } from '../../../types/api.type';
import { getFilterValue } from '../../listFilterSearchParams';

export const created_at_from: FilterField = {
  name: 'created_at_from',
  id: 'created_at',
  operator: 'greater_equal_than',
  element: (
    <DateFilterField
      name="created_at_from"
      label="Created At"
    />
  )
};

export const created_at_to: FilterField = {
  name: 'created_at_to',
  id: 'created_at',
  operator: 'lesser_equal_than',
  element: <DateFilterField name="created_at_to" />
};

export const updated_at_from: FilterField = {
  name: 'updated_at_from',
  id: 'updated_at',
  operator: 'greater_equal_than',
  element: (
    <DateFilterField
      name="updated_at_from"
      label="Updated At"
    />
  )
};

export const updated_at_to: FilterField = {
  name: 'updated_at_to',
  id: 'updated_at',
  operator: 'lesser_equal_than',
  element: <DateFilterField name="updated_at_to" />
};

export const created_at_from_to = [created_at_from, created_at_to];
export const updated_at_from_to = [updated_at_from, updated_at_to];
export const created_updated_at_from_to = [...created_at_from_to, ...updated_at_from_to];

/** Hydrate shared created/updated date filter fields from URL/list filter state. */
export const getCreatedUpdatedAtFromTo = (filterBy?: Filter[]): FilterField[] => [
  {
    ...created_at_from,
    value: getFilterValue(filterBy, 'created_at', 'greater_equal_than')
  },
  {
    ...created_at_to,
    value: getFilterValue(filterBy, 'created_at', 'lesser_equal_than')
  },
  {
    ...updated_at_from,
    value: getFilterValue(filterBy, 'updated_at', 'greater_equal_than')
  },
  {
    ...updated_at_to,
    value: getFilterValue(filterBy, 'updated_at', 'lesser_equal_than')
  }
];
